/**
 * Converts a string to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @example
 * kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * @function kebabCase
 * @param {string} str The string to convert.
 * @return {string} Returns the kebab cased string.
 */
export default function kebabCase(str) {
	if (typeof str !== 'string') return '';

	return str
		.trim()
		.replace(/(\B[A-Z]|\B[0-9])/g, '-$1')
		.replace(/[\s_]+/g, '-')
		.toLowerCase();
}
